import { useTranslations } from 'next-intl';

import { cn } from '@/utils/cn';

interface SpinnerProps {
  size?: number;
  className?: string;
}

export const Spinner: React.FC<SpinnerProps> = ({ size = 50, className = '' }: SpinnerProps) => {
  const t = useTranslations('common.states');

  return (
    <svg
      aria-label={t('loading')}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      className={cn('animate-spin', className)}
    >
      <path fill="currentColor" d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z" opacity=".25" />
      <path
        fill="currentColor"
        d="M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z"
      />
    </svg>
  );
};

interface LoadingBoxProps {
  width: number;
  height: number;
  className?: string;
}

export const LoadingBox: React.FC<LoadingBoxProps> = ({ width, height, className = '' }: LoadingBoxProps) => {
  return (
    <div
      style={{ width, height }}
      className={cn(
        'relative rounded-md overflow-hidden before:absolute before:inset-0 before:-translate-x-full before:animate-[shimmer_3s_infinite] before:bg-linear-to-r before:from-transparent before:via-skeleton before:to-transparent',
        className,
      )}
    />
  );
};

interface LoadingBoxSkeletonProps {
  height: number;
  className?: string;
}

export const LoadingBoxSkeleton: React.FC<LoadingBoxSkeletonProps> = ({ height, className = '' }: LoadingBoxSkeletonProps) => {
  return (
    <div
      style={{ height }}
      className={cn(
        'w-full relative rounded-md overflow-hidden before:absolute before:inset-0 before:-translate-x-full before:animate-[shimmer_3s_infinite] before:bg-linear-to-r before:from-transparent before:via-skeleton before:to-transparent',
        className,
      )}
    />
  );
};
